import { render, staticRenderFns } from "./QualificationButtons.vue?vue&type=template&id=08db18ee&"
import script from "./QualificationButtons.vue?vue&type=script&lang=js&"
export * from "./QualificationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports